"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ResizableRect = _interopRequireDefault(require("./ResizableRect"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _ResizableRect.default;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-resizable-rotatable-draggable/lib/index.js
// module id = 1069
// module chunks = 0